import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import reducer from './reducers';

export default function configureStore(initialState) {
  return configureReduxStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => {
      const m = getDefaultMiddleware();
      if (process.env.NODE_ENV === 'development') {
        m.push(createLogger());
      }
      return m;
    },
  });
}
